export default {
  // taken from https://webdesign.tutsplus.com/tutorials/how-to-lazy-load-embedded-youtube-videos--cms-26743
  init(selector) {
    const youtube = document.querySelectorAll(selector);
    
    for (let i = 0; i < youtube.length; i++) {
      const source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/sddefault.jpg";
      const image = new Image();
      image.src = source;
      image.addEventListener("load", () => {
        youtube[i].appendChild(image);
      });

      youtube[i].addEventListener("click", (event) => {
        const element = youtube[i];
        const iframe = document.createElement("iframe");

        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("src", "https://www.youtube.com/embed/" + element.dataset.embed + "?rel=0&showinfo=0&autoplay=1");

        element.innerHTML = "";
        element.appendChild(iframe);
      });
    };
  }
}